import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/components/auth/Auth'
import Login from '@/components/auth/Login'
import Dashboard from '@/components/dashboard/Dashboard'
import MenuCentral from '@/components/dashboard/MenuCentral'

// usuario
import PasswordUser from '@/components/user/PasswordUser'
import CapitanPort from '@/components/user/CapitanPort'
import AdminUser from '@/components/user/AdminUser'


// Reportes
import ReportPendingOp from '@/components/reports/ReportsPendingOperations'



// componente que embebe el reporte
import Report from '@/components/report/report'

// reporte de los ingresos por distintos conceptos
import ReportEnter from '@/components/finanzas/ReportEnter'

// Baja de una embarcacion
import DownShip from '@/components/matriculacion/DownShip'

// reimpresion de documentos
import ReimpresionShip from '@/components/finanzas/ReimpresionShip'

// solicitud documento
import Certificados from '@/components/certificados/Certificados'
import CertificadoAdmin from '@/components/certificados/certificadosAdmin'
import DafDepositos from '@/components/certificados/DafDepositos'

Vue.use(Router)

function rutaResguardada(to, from, next){
  if(Vue.auth.loggedIn()){
    next('/dashboard')
  }else{
    next();
  }
}

const routes=[
  {path:'/', redirect:'/certificados/certificado', name:'inicio2'},
  {path:'/report/:tpdf', component:Report},
  {
    path:'/auth',
    component:Auth,
    redirect:'/auth/login',
    children:[
      {path:'login', component: Login, name: 'login', beforeEnter:rutaResguardada}
    ]
  },
  {
    path:'/certificados',
    component:Certificados,
    redirect:'/certificados/certificado',
    children:[
      {path:'certificado', component: Certificados, name: 'solicitud', beforeEnter:rutaResguardada}
    ]
  },
  {
    path:'/dashboard',
    component:Dashboard,
    name:'dashboard',
    redirect:'dashboard/central',
    meta: { requiresAuth : true },
    children:[
      {path:'central', component:MenuCentral},
      {path:'users', component:AdminUser},
      {path:'password', component:PasswordUser},
      {path:'certificado', component:CertificadoAdmin},
      {path:'daf', component:DafDepositos}
    ]
  }
]

export default new Router({
  // mode: 'history',
  mode:'hash',
  base: __dirname,
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js